import { motion, AnimatePresence } from "framer-motion";
import "../Css/Progressbar.css";
// const  = 13; // dynamicznie podstawiasz ten procent

const progressVariants = {
    rest: {  height: ".5rem", minWidth: ".52rem"},
    hover: {
        height: "1rem",
        minWidth: "1rem",
        transition: { duration: 0.2 },
    },
};
const percentVariants = {
  hidden: { opacity: 0, x: 0, height: "0rem"},
  visible: { opacity: 1, x: 0,height: ".5rem", transition: { duration: 0.3 } },
  exit: { opacity: 0, x: 0,height: ".5rem", transition: { duration: 0.2 } },
};
const percentHeight = {
      hidden: { height: "0rem", width:"0%", opacity: 0, transition: { duration: 0.2 } },
      visible: { height: ".5rem", width:"15%", opacity: 1, transition: { duration: 0.2 } }
}
const statusVariantsWrapper = {
       rest: {  width: "100%", height: ".5rem", minWidth: ".52rem"},
    hover: {
        width: "85%",
        height: "1rem",
        minWidth: "1rem",
        transition: { duration: 0.2 },
    },
}
export default function ProgressBar({ progress, hovered }) {
return (
    <div className="progress-area">
        <motion.div
            style={{ width: "85%", float: "left" }}
            variants={statusVariantsWrapper}
            initial="rest"
            animate={hovered ? "hover" : "rest"}
            className="status"
        >
            <motion.div
                className="progress-wrapper"
                variants={progressVariants}
                style={{}}
            >
                <motion.div
                    className="progress-bar"
                    variants={progressVariants}
                    style={{ width: `${progress}%` }}
                />
            </motion.div>
        </motion.div>
        <AnimatePresence style={{ width: "15%", float: "left" }}>
            {hovered && (
                <motion.div
                    className="progress-percent"
                    variants={percentVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    style={{ width: "15%" }}
                >
                    <motion.div style={{ width: "15%" }} variants={percentHeight}>&nbsp;&nbsp;
                        {progress}%
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    </div>
);
}
